// Dependencies
require("section/contact");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/contact/index.js
 ** module id = 175
 ** module chunks = 0 1
 **/